import { ErrorMessage, useField, Field } from "formik";
import { BiSearch } from "react-icons/bi";

export const SimpleInputField = ({ label, active, ...props }) => {
  return (
    <div className="w-full mb-4">
      {label && (
        <label className="my-label" htmlFor={props.name}>
          {label}
        </label>
      )}
      <input className={`my-input ${active && "border-green-400"}`} id={props.name} {...props} />
    </div>
  );
};

export const SearchInputField = ({ ...props }) => {
  return (
    <div className=" relative w-full  overflow-hidden ">
      <BiSearch className="absolute left-3 top-5 transform -translate-y-1/2 text-zinc-400" />
      <input
        className="placeholder-opacity-75 focus:outline-none w-full text-sm text-black placeholder-gray-500 border border-gray-200 rounded-md py-2 pl-10"
        type="text"
        {...props}
      />
    </div>
  );
};

export const InputField = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className="mb-4 text-inherit">
      <label className="my-label" htmlFor={field.name}>
        {label}
      </label>
      <input
        className={`my-input ${meta.touched && meta.error && "border-solid border border-red-300"}`}
        {...field}
        {...props}
        autoComplete="off"
      />
      <ErrorMessage component="div" name={field.name} className="text-red-400 text-xs" />
    </div>
  );
};

export const TextAreaField = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className="mb-4">
      <label className="my-label" htmlFor={field.name}>
        {label}
      </label>
      <textarea
        className={`my-input ${meta.touched && meta.error && "border-solid border border-red-300"}`}
        {...field}
        {...props}
        autoComplete="off"
      />
      <ErrorMessage component="div" name={field.name} className="text-red-400 text-xs" />
    </div>
  );
};
export const SelectField = ({ children, label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className="mb-4">
      <label className="my-label" htmlFor={field.name}>
        {label}
      </label>
      <Field
        name="brand"
        as="select"
        {...field}
        {...props}
        className={`my-input  ${
          meta.touched && meta.error && "border-solid border border-red-300"
        }`}
      >
        {children}
      </Field>
      <ErrorMessage component="div" name={field.name} className="text-red-400 text-xs" />
    </div>
  );
};
